import React from 'react'
import "../styles/pageStyles/ManageAccount.scss"
import SettingsSideBar from '../components/SettingsSideBar'
import Password from '../components/ManageAccount/Password'
import ProfileEdit from '../components/ManageAccount/ProfileEdit'

const ManageAccount = ({ formToDisplay }) => {
    return (
        <div className='manage-account'>
            <SettingsSideBar />
            {/* Render different forms based on which link is clicked on sidebar, via passing prop from App.js  */}
            {

                formToDisplay === "passwordEdit" && <Password />

            }
            {

                formToDisplay === "profileEdit" && <ProfileEdit />

            }
        </div>
    )
}

export default ManageAccount